import React from 'react';
import { Auth } from 'aws-amplify';
import styles from './GiideWithStep.module.css';
import { LoadingOutlined } from '@ant-design/icons';

interface IProps {
  giideId: string;
  closeModal?: () => void;
  small?: boolean;
}

const GiidePreview: React.FC<IProps> = ({ giideId, closeModal, small }) => {
  const PREVIEW_URL = process.env.REACT_APP_PREVIEW_URL;
  const [token, setToken] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    Auth.currentAuthenticatedUser({
      bypassCache: true,
    })
      .then(user => setToken(user.signInUserSession.idToken.jwtToken))
      .catch(err => console.log(err));
  }, []);

  return (
    <div
      className={`${styles.giidePreviewWrapper} ${
        small ? styles.giidePreviewWrapperSmall : ''
      }`}
    >
      {!token ? (
        <div className={styles.loadingPreviewWrapper}>
          <LoadingOutlined spin className={styles.loadingPreviewIcon} />
        </div>
      ) : (
        <iframe
          className={`${styles.giidePreview} ${
            small ? styles.giidePreviewSmall : ''
          }`}
          title="Giide module player"
          src={`${PREVIEW_URL}giide-${giideId}?embed=1&preview=true&token=${token}`}
          frameBorder="0"
        />
      )}
    </div>
  );
};

export default GiidePreview;
